import {
  CoreDialog,
  CoreDialogTitle,
  CoreDialogContent,
  CoreDialogActions,
  CoreButton,
  CoreBox,
  CoreTypography,
  CoreIconButton,
} from '@youscience/core';
import { Close as CloseIcon } from '@mui/icons-material';
import { CCR_VIDEO_URL, CCR_OPT_IN_FORM_URL } from '@constants/urls';

interface LearnMoreModalProps {
  open: boolean;
  onClose: () => void;
}

export const LearnMoreModal = ({ open, onClose }: LearnMoreModalProps) => {
  const handleRequestAccess = () => {
    window.open(CCR_OPT_IN_FORM_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <CoreDialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1.5,
        },
      }}
    >
      <CoreDialogTitle>
        <CoreBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <CoreTypography variant='h6'>New College and Career Readiness Planner</CoreTypography>
          <CoreIconButton onClick={onClose} size='small' sx={{ marginLeft: 2 }} aria-label='Close dialog'>
            <CloseIcon />
          </CoreIconButton>
        </CoreBox>
      </CoreDialogTitle>

      <CoreDialogContent>
        <CoreBox
          sx={{
            borderRadius: 1,
            overflow: 'hidden',
            backgroundColor: '#000',
          }}
        >
          <video controls width='100%' preload='metadata' style={{ display: 'block' }} aria-label='College and Career Readiness Planner overview video'>
            <source src={CCR_VIDEO_URL} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </CoreBox>
      </CoreDialogContent>

      <CoreDialogActions sx={{ padding: 3, paddingTop: 0 }}>
        <CoreButton
          onClick={onClose}
          variant='outlined'
          color='secondary'
          sx={{ borderRadius: 999, textTransform: 'none' }}
        >
          Cancel
        </CoreButton>
        <CoreButton
          onClick={handleRequestAccess}
          variant='contained'
          color='secondary'
          sx={{ borderRadius: 999, textTransform: 'none' }}
        >
          Request access
        </CoreButton>
      </CoreDialogActions>
    </CoreDialog>
  );
};
